//import { componentLoader } from "e3-components";
import loadable from "@loadable/component";

export const createTabMenuSlice = (set) => ({
  chageValue: "",
  menuList: [
    {
      menuId: "Z999999999",
      menuName: "HOME",
      selected: true,
      menuNameList: "HOME",
      //component: componentLoader('/Home'),
      component: loadable(() => import("@/pages/Home")),
    },
  ],
  setMenuList: (menuList) => {
    set((state) => {
      state.tabMenu.menuList = menuList;
    });
  },
  changeTab: (menuId) => {
    set((state) => {
      state.tabMenu.menuList = state.tabMenu.menuList.map((x) => {
        if (x.menuId === menuId) {
          return { ...x, selected: true };
        } else return { ...x, selected: false };
      });
    });
  },
  changeTabName: (menuId, menuName) => {
    set((state) => {
      state.tabMenu.menuList = state.tabMenu.menuList.map((x) => {
        if (x.menuId === menuId) {
          return { ...x, orgMenuName: x.menuName, menuName: menuName };
        } else return { ...x };
      });
    });
  },
  restoreTabName: (menuId) => {
    set((state) => {
      state.tabMenu.menuList = state.tabMenu.menuList.map((x) => {
        if (x.menuId === menuId) {
          // return { ...x, menuName: x.orgMenuName };
          return { ...x, ...(x.orgMenuName && { menuName: x.orgMenuName }) };
        } else return { ...x };
      });
    });
  },
  addTabMenu: (menuId, menuName, helpYn, menuNameList, component) => {
    set((state) => {
      const menu = state.tabMenu.menuList.find((e) => e.menuId === menuId);
      if (menu) {
        state.tabMenu.menuList = state.tabMenu.menuList.map((x) => {
          if (x.menuId === menuId) {
            return { ...x, selected: true };
          } else return { ...x, selected: false };
        });
      } else {
        state.tabMenu.menuList = state.tabMenu.menuList.map((x) => {
          return { ...x, selected: false };
        });
        // state.tabMenu.menuList.concat({
        //   menuId: menuId,
        //   menuName: menuName,
        //   helpYn: helpYn,
        //   selected: true,
        //   component: component,
        // });
        // 열린탭이 맨앞으로 오도록 - 2024-10-25 jh.park
        state.tabMenu.menuList.splice(1, 0, {
          menuId: menuId,
          menuName: menuName,
          helpYn: helpYn,
          selected: true,
          menuNameList: menuNameList,
          component: component,
        });
      }
    });
  },
  closeTab: (menuId) => {
    set((state) => {
      state.tabMenu.menuList = state.tabMenu.menuList.filter((f) => {
        return f.menuId !== menuId;
      });
      // .map((e, index, array) => {
      //   if (index === array.length - 1) return { ...e, selected: true };
      //   else return { ...e, selected: false };
      // });
    });
  },
  closeAllTab: () => {
    set((state) => {
      const selectMenu = state.tabMenu.menuList.filter((f) => {
        return f.selected === true;
      });
      if (selectMenu[0].menuId === "Z999999999") {
        state.tabMenu.menuList = [{ ...state.tabMenu.menuList[0], selected: true }];
      } else {
        // 전체 닫기시 선택된 탭은 안 닫히도록 - 2024-10-25 jh.park
        state.tabMenu.menuList = [{ ...state.tabMenu.menuList[0] }, { ...selectMenu[0] }];
      }
    });
  },
  setChangeAction: (value) => {
    set((state) => {
      state.tabMenu.chageValue = value;
    });
  },
  resetTabMenuList: () => {
    set((state) => {
      (state.tabMenu.chageValue = ""),
        (state.tabMenu.menuList = [
          {
            menuId: "Z999999999",
            menuName: "HOME",
            selected: true,
            menuNameList: "HOME",
            //component: componentLoader("/Home"),
            component: loadable(() => import("@/pages/Home")),
          },
        ]);
    });
  },
});
